import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import React, { useState } from 'react'
import { AttachementsUpload } from '../../../shared_elements/components';
import { globalPostService, globalPutService } from '../../../utils/globalApiServices';
import { addReferenceDocumentsApi, updateReferenceDocumentsApi } from '../apiServices';
import { checkApiStatus } from '../../../utils';
import moment from 'moment';
import { backendDateFormat, fieldDateFormat } from '../../../constants';
import { useSnackbar } from 'notistack';
import { setFileUploadDetails } from '../../../shared_elements/actions';
import { useDispatch, useSelector } from 'react-redux';
import { formatBytes } from '../../../utils/fileUpload';
import { trackActivity } from '../../../utils/mixpanel';
import { regexConstants } from '../../../constants/regEx';
import LessMoreTextFieldComp from '../../../shared_elements/components/LessMoreTextFieldComp';

const ReferenceDocummentsCRU = ({ addEditReferenceDocument,fileUpload, modeType, onToggleModal, params, getResponseBack, openAttachment }) => {
    const dispatch=useDispatch()
    const { storageDetails } = useSelector((state) => state.leases);
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [referenceDocument, setReferenceDocument] = useState(addEditReferenceDocument?.data);
    const [error, setError] = useState({});
    const [uploadFile, setUploadFile] = useState([]);

    const handelInputChange = (key, value) => {
        setReferenceDocument({ ...referenceDocument, [key]: value });
    }

    const onFileChange = (data) => {
        setUploadFile(data);
        dispatch(setFileUploadDetails({attachments:data}))
        setError(prev => ({ ...prev, attachments: "" }));
    }


    const handelAddEditReferenceDocument = () => {
        let validationInputs = {};
        validationInputs = {
            name: referenceDocument?.name ? "" : "Please enter Name",
            validity_end_date: referenceDocument?.validity_end_date ? "" : "Please select Validity End Date",
            attachments: (!referenceDocument?.attachments?.length && uploadFile.length === 0) ? "Please upload Attachment(s)*" : "",

        };
        if (Object.keys(validationInputs).every((K) => { return validationInputs[K] === ""; })) {
            setLoading(true);
            let payload = Object.assign({}, referenceDocument);
            payload = {
                ...payload,
                validity_start_date: payload.validity_start_date ? payload.validity_start_date : null,
            }
            if (referenceDocument.id) {
                globalPutService(updateReferenceDocumentsApi({ ...params, slug: referenceDocument?.slug }), payload)
                    .then(async (response) => {
                        if (checkApiStatus(response)) {
                            if (uploadFile?.length > 0) {
                                 fileUpload(referenceDocument.slug,'updated')
                            }
                            onToggleModal();
                            getResponseBack();
                            setLoading(false);
                            enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: "right", vertical: "top" }, });
                            trackActivity('Item Edited', { page_title: `Edit Reference Document`, success_msg: response?.data?.message, item_id: referenceDocument?.id, payload: payload, response: response?.data })
                        } else {
                            setLoading(false);
                            enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } })
                            trackActivity('Item Edited', { page_title: `Edit Reference Document`, error_msg: response?.data?.message, item_id: referenceDocument?.id, payload: payload, response: response?.data })
                        }
                    })
            } else {
                globalPostService(addReferenceDocumentsApi({ leaseSlug: params?.leaseSlug }), payload)
                    .then(async (response) => {
                        if (checkApiStatus(response)) {
                            if (uploadFile?.length > 0) {
                                 fileUpload(response?.data?.data?.slug,'created')
                            }
                            onToggleModal();
                            getResponseBack();
                            setLoading(false);
                            enqueueSnackbar(response?.data?.message, {
                                variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }
                            })
                            trackActivity('Item Added', { page_title: `Add Reference Document`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: payload, response: response?.data })
                        } else {
                            setLoading(false);
                            enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } })
                            trackActivity('Item Added', { page_title: `Add Reference Document`, error_msg: response?.data?.message, item_id: null, payload: payload, response: response?.data })
                        }
                    })
            }
        } else {
            setError(validationInputs);
            trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Reference Document`, error_msg: validationInputs, })
        }
    }

    const onRestErrorKey = (keyParam) => {
        setError({ ...error, [keyParam]: '' })
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Reference Document`, page_type: page_type, })
    }
    return (
        <>
            <Dialog
                aria-labelledby="customized-dilog-title"
                className="add-lease-dialog"
                maxWidth="md"
                fullWidth
                open={addEditReferenceDocument.modal}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                    <Typography className="dialog-header-title">
                        {modeType === 'add' ? "Add Reference Documents" : modeType === 'edit' ? 'Edit Reference Documents' : 'View Reference Documents'}
                    </Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <TextField
                                id='name'
                                label="Name"
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 255 } }}
                                variant='outlined'
                                size='small'
                                margin='normal'
                                fullWidth
                                required
                                value={referenceDocument?.name}
                                onChange={(e) => {
                                    regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("name", e.target.value.trimStart()) : e.preventDefault()
                                    setError(prev => ({ ...prev, name: "" }));
                                }}
                                error={error.name}
                                helperText={error.name}
                                disabled={modeType === "view"}
                            />
                        </Grid>
                        <Grid size={{ md: 6, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Validity Start Date"
                                    slotProps={{
                                        popper: { placement: 'bottom-end' },
                                        textField: {
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.validity_start_date || false,
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                handelInputChange("validity_start_date", null);
                                                onRestErrorKey("validity_start_date");
                                            }
                                        }
                                    }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}
                                    value={
                                        referenceDocument?.validity_start_date
                                            ? moment(referenceDocument.validity_start_date)
                                            : null
                                    }
                                    onChange={(newValue) => {
                                        // handelInputChange("validity_start_date", moment(newValue).format(backendDateFormat));
                                        const isValid = moment(newValue)?.isValid();
                                        const formattedDate = isValid ? moment(newValue).format(backendDateFormat) : null;
                                        handelInputChange("validity_start_date", formattedDate);
                                        if (isValid) {
                                            onRestErrorKey("validity_start_date");
                                        }
                                    }}
                                    disabled={modeType === "view"}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 6, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Validity End Date"
                                    value={referenceDocument?.validity_end_date ? moment(referenceDocument.validity_end_date) : null}
                                    minDate={referenceDocument?.validity_start_date ? moment(referenceDocument.validity_start_date) : null}
                                    slotProps={{
                                        popper: { placement: 'bottom-end' },
                                        textField: {
                                            size: "small",
                                            margin: "normal",
                                            required: true,
                                            InputLabelProps: { shrink: true },
                                            error: Boolean(error.validity_end_date),
                                            helperText: error.validity_end_date || '',
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                handelInputChange("validity_end_date", null);
                                                onRestErrorKey("validity_end_date");
                                            }
                                        }
                                    }}
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        const formattedDate = isValid ? moment(data).format(backendDateFormat) : null;
                                        handelInputChange("validity_end_date", formattedDate);
                                        if (isValid) {
                                            onRestErrorKey("validity_end_date");
                                        }
                                    }}
                                    format={fieldDateFormat}
                                    sx={{ width: "100%" }}
                                    disabled={modeType === "view"}
                                />
                            </LocalizationProvider>
                        </Grid>
                        {modeType === "view" ? <Grid item size={{ md: 12, xs: 12 }}>
                            <LessMoreTextFieldComp label='Description' value={referenceDocument?.description || ""} />
                        </Grid> :
                            <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                    id='description'
                                    label="Description"
                                    variant='outlined'
                                    size='small'
                                    margin='normal'
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                    fullWidth
                                    rows={3}
                                    multiline
                                    value={referenceDocument?.description}
                                    onChange={(e) => {
                                        regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? handelInputChange("description", e.target.value.trimStart()) : e.preventDefault();
                                    }}
                                    disabled={modeType === "view"}
                                />
                            </Grid>}
                        <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>
                             <Box className="responsive-buttons">
                            {referenceDocument?.id && referenceDocument?.attachments?.length ? (
                                <Button onClick={() => { openAttachment(); handleItemClicked('ViewAttachments Button') }} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>
                                    {`${referenceDocument.attachments.length}: Attachments`}
                                </Button>
                            ) : null}
                            <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary'>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                            </Box>
                            {modeType !== "view" && (
                                <>
                                    <AttachementsUpload onFileChange={onFileChange} docError = {error.attachments} attachments={referenceDocument?.attachments} remainingStorage={storageDetails?.remaining_storage}/>  
                                </>
                            )}
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{marginRight: '10px'}}>
                    <Button className='cancel-btn' disabled={loading} variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
                    {modeType === "view" ? null : 
                    <Button variant='contained' size='small' className='btn-primary' onClick={() => { handleItemClicked('Save Button'); handelAddEditReferenceDocument() }}>
                        {loading ? <CircularProgress color='inherit' size={24} /> : "Save"}
                    </Button>}
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ReferenceDocummentsCRU;